// Typed access to featurePages.json — the single list of public /features
// pages shared with the server (api/index.js, api/ssrPublicPages.js) and the
// sitemap cron. Copy lives in ui.json under features_pages.<key>.
import registry from './featurePages.json';

export type FeatureTier = 'free' | 'pro' | 'ultra';
export type FeatureDemo = 'receipt' | 'trends' | 'assistant' | 'battle' | 'duel' | 'history' | 'insights';

export interface FeaturePage {
  slug: string;
  /** i18n key under features_pages (slug with underscores). */
  key: string;
  /** Lowest plan that includes the feature. */
  tier: FeatureTier;
  demo: FeatureDemo;
  icon: string;
  related: string[];
  faqCount: number;
  /** Clerk feature slugs whose /pricing comparison row links here. */
  clerkFeatures?: string[];
  /** English phrases linked to this page inside public posts (services/featureLinks.js). */
  linkPhrases?: string[];
}

export const FEATURES_HUB_PATH: string = registry.hubPath;
export const LANDING_FEATURE_SLUGS = registry.landingLinks.features;
export const LANDING_STEP_SLUGS = registry.landingLinks.steps;
export const FEATURE_PAGES = registry.pages as FeaturePage[];
export const FEATURE_TIERS: FeatureTier[] = ['free', 'pro', 'ultra'];

export const getFeaturePage = (slug?: string) => FEATURE_PAGES.find(p => p.slug === slug) || null;
export const featurePath = (slug: string) => `${FEATURES_HUB_PATH}/${slug}`;
export const featurePageForClerkFeature = (clerkSlug: string) => FEATURE_PAGES.find(p => p.clerkFeatures?.includes(clerkSlug)) || null;
